export const baseUrl = "https://api.beyondmedical.co.id/report-form/api"
export const baseUrlUpload = "https://api.beyondmedical.co.id/report-form"

// export const baseUrl = "https://apidev.beyondmedical.co.id/report-form/api"
// export const baseUrlUpload = "https://apidev.beyondmedical.co.id/report-form"
